import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

// The inverse of ProtectedRoute: keeps an already-signed-in admin off /login.
//
// Reads the context rather than localStorage — the session is an httpOnly
// cookie now, so "is there a token in storage?" is no longer a question the
// browser can answer.
const AuthRedirect = ({ children }) => {
  const { isAuthenticated, loading, mfaEnrolled } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <i className="fa-solid fa-spinner animate-spin"></i>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={mfaEnrolled ? "/" : "/mfa-setup"} replace />;
  }

  return children;
};

export default AuthRedirect;
